package com.kinoshazam.screens.allVideo.expanded

import androidx.compose.runtime.Composable
import presentation.screens.allVideos.AllVideosMVIAction
import presentation.screens.allVideos.AllVideosState

@Composable
actual fun ExpandedAllVideosWindow(
    state: AllVideosState,
    onAction: (AllVideosMVIAction) -> Unit,
) {
}